
import React from "react";
import { Spinner } from "reactstrap";
const Loader = (props) => {

    return(
        <React.Fragment>
               <div style={{display: "flex", justifyContent: "center", alignItems:"center", height: "inherit", backgroundColor: "white" }}>
                    <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" ></Spinner>
                </div>
        </React.Fragment>
    );
}
//type="grow"
export default Loader;